import React, { useState, useEffect, useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Labels } from "components/atoms/input/input"
import ClassNames from "classnames"

interface props {
  canvasId: string
}

const RelativeChart = React.memo((props: props) => {
  const { canvasId } = props
  const plotTypeSelector = (state: any) => state.chart[canvasId].plotType
  const providersSelector = (state: any) => state.chart[canvasId].providers
  const relativeChartFlagSelector = (state: any) =>
    state.chart[canvasId].relativeChartFlag
  const plotType = useSelector(plotTypeSelector)
  const providers = useSelector(providersSelector)
  const relativeChartFlag = useSelector(relativeChartFlagSelector)
  const [_provider, _controller, _procs] = providers
  const [viewType, setViewType] = useState(0)

  // 絶対座標
  const setAbsoluteMDPolicy = () => {
    if (plotType.key === "PandF") return
    const view = _controller.Chart.get_Chart().get_View()
    if (view && view.set_MultiDataPolicy)
      view.set_MultiDataPolicy({
        $: 0,
      })
  }

  // 相対座標
  const setRelativeMDPolicy = () => {
    if (plotType.key === "PandF") return
    const view = _controller.Chart.get_Chart().get_View()
    if (view && view.set_MultiDataPolicy)
      view.set_MultiDataPolicy({
        $: 1,
      })
  }

  useEffect(() => {
    if (!_controller) return
    if (viewType === 0) setAbsoluteMDPolicy()
    if (viewType === 1) setRelativeMDPolicy()
  }, [viewType])

  return (
    <div
      className={ClassNames("btn-chart-relative filter-control-item", {
        disabled: !relativeChartFlag,
      })}
    >
      <Labels
        className="btn-segmented-control btn-thin liquid-control"
        labelList={[{ name: "絶対", id: 0 }, { name: "相対", id: 1 }]}
        checked={viewType}
        onChange={setViewType}
        disabled={!relativeChartFlag}
      />
    </div>
  )
})

export default RelativeChart
